import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthModule } from '../../../modules/auth/auth.module';
import { BreadcrumbModule } from '../crumbs/breadcrumb.module';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgbModule,
    AuthModule,
    BreadcrumbModule,
  ],
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
})
export class NavbarModule {}
